import React, { useState } from 'react';
import { VolumeSlider } from '../../../components/widgets/VolumeSlider';
import { faMicrophone, faMicrophoneSlash, faVolume, faVolumeSlash } from '@fortawesome/pro-light-svg-icons';
import { Select } from '../../../components/widgets/Select';

type BeaconVolumeManagerProps = {
  desktopVolume: number;
  micVolume: number;
  isDesktopUnmuted: boolean;
  isMicUnmuted: boolean;
  desktopDevices: { label: string; value: string; enabled: boolean }[];
  micDevices: { label: string; value: string; enabled: boolean }[];
  selectedDesktopDevice: string;
  selectedMicDevice: string;
  onDesktopVolumeChange: (volume: number) => void;
  onMicVolumeChange: (volume: number) => void;
  onDesktopMuteToggle: () => void;
  onMicMuteToggle: () => void;
  onDesktopDeviceChange: (deviceId: string) => void;
  onMicDeviceChange: (deviceId: string) => void;
};

export const BeaconVolumeManager = ({
  desktopVolume,
  micVolume,
  isDesktopUnmuted,
  isMicUnmuted,
  desktopDevices,
  micDevices,
  selectedDesktopDevice,
  selectedMicDevice,
  onDesktopVolumeChange,
  onMicVolumeChange,
  onDesktopMuteToggle,
  onMicMuteToggle,
  onDesktopDeviceChange,
  onMicDeviceChange,
}: BeaconVolumeManagerProps) => {
  const [localDesktopVolume, setLocalDesktopVolume] = useState(desktopVolume);
  const [localMicVolume, setLocalMicVolume] = useState(micVolume);
  const [localDesktopUnmuted, setLocalDesktopUnmuted] = useState(isDesktopUnmuted);
  const [localMicUnmuted, setLocalMicUnmuted] = useState(isMicUnmuted);

  return (
    <div className='grid h-full w-full grid-cols-2 gap-2 md:h-fit' tabIndex={-1}>
      <div className='flex flex-1 flex-col justify-between' tabIndex={-1}>
        <VolumeSlider
          id='desktop-volume-button'
          onRelease={() => onDesktopVolumeChange(localDesktopVolume)}
          volumeOverride={localDesktopVolume}
          volumeState={[localDesktopVolume, setLocalDesktopVolume]}
          buttonState={[localDesktopUnmuted, ((val) => {
            setLocalDesktopUnmuted(val as boolean);
            onDesktopMuteToggle();
          }) as React.Dispatch<React.SetStateAction<boolean>>]}
          enabledIcon={faVolume}
          disabledIcon={faVolumeSlash}
        />
        <Select data={desktopDevices} selected={selectedDesktopDevice} onChange={onDesktopDeviceChange} />
      </div>
      <div className='flex flex-col justify-between' tabIndex={-1}>
        <VolumeSlider
          id='mic-volume-button'
          onRelease={() => onMicVolumeChange(localMicVolume)}
          volumeOverride={localMicVolume}
          volumeState={[localMicVolume, setLocalMicVolume]}
          buttonState={[localMicUnmuted, ((val) => {
            setLocalMicUnmuted(val as boolean);
            onMicMuteToggle();
          }) as React.Dispatch<React.SetStateAction<boolean>>]}
          enabledIcon={faMicrophone}
          disabledIcon={faMicrophoneSlash}
        />
        <Select data={micDevices} selected={selectedMicDevice} onChange={onMicDeviceChange} />
      </div>
    </div>
  );
};
